import { getConfigBaseUrl, getConfigGraphBaseUrl } from '../../../services/apiService';
import { getCounterpartyId } from '../../../services/authService';
import { apiCall, createApiThunk, graphqlCall } from '../../../utils/api';
import { print } from 'graphql';
import { getModulesQuery } from './userGroupQueries';

export const getUserGroupsThunk = createApiThunk('GET_USER_GROUPS', apiCall);
export const getGroupDetailsThunk = createApiThunk('GET_SELECTED_GROUP', apiCall);
export const saveUserGroupThunk = createApiThunk('SAVE_USER_GROUPS', apiCall);
export const editUserGroupThunk = createApiThunk('EDIT_USER_GROUPS', apiCall);
export const getModulesThunk = createApiThunk('GET_MODULES', graphqlCall);

export const getUserGroups = () => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/groups/`;
  return dispatch(getUserGroupsThunk({ url, method: 'GET' }));
};

export const getGroupDetails = (groupId: string) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/groups/${groupId}`;
  return dispatch(getGroupDetailsThunk({ url, method: 'GET' }));
};

export const getModules = () => {
  return function (dispatch: AppDispatch) {
    const url = getConfigGraphBaseUrl();
    const query = print(getModulesQuery);
    dispatch(getModulesThunk({ url, query }));
  };
};

export const saveUserGroup = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/groups/`;
  return dispatch(saveUserGroupThunk({ url, method: 'POST', data }));
};

export const editUserGroup = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/groups/${data.groupId}`;
  return dispatch(editUserGroupThunk({ url, method: 'PUT', data }));
};
